import React, { useMemo } from "react";
import { ProgressBar, Badge } from "react-bootstrap";

const SchoolProfileProgress = ({ user, docData, workingHours, hoursConfigured }) => {
  const result = useMemo(() => {
    const personalFields = [
      user?.name || user?.full_name || "",
      user?.email || "",
      user?.contact_number || user?.phone || "",
      user?.address || "",
      user?.city_id || "",
      user?.zipcode || ""
    ];

    const bankFields = [
      "bank_name",
      "account_holder_name",
      "account_number",
      "ifsc",
      "branch"
    ];
    const proofFields = [
      "id_proof_type",
      "id_proof_number",
      "id_proof_file",
      "license_file",
      "photo_file"
    ];

    const personalComplete = personalFields.every((v) => String(v || "").trim());
    const bankComplete = bankFields.every((k) => (docData?.[k] || "").toString().trim());
    const proofComplete = proofFields.every((k) => (docData?.[k] || "").toString().trim());
    const hoursComplete = typeof hoursConfigured === "boolean"
      ? hoursConfigured
      : (
          Array.isArray(workingHours) &&
          workingHours.some(
            (h) =>
              h.status === "open" &&
              String(h.opening_time || "").trim() &&
              String(h.closing_time || "").trim()
          )
        );

    const sections = [
      { key: "personal", label: "Personal Details", done: personalComplete },
      { key: "bank", label: "Bank Details", done: bankComplete },
      { key: "proof", label: "Documents", done: proofComplete },
      { key: "hours", label: "Working Hours", done: hoursComplete }
    ];

    const total = sections.length;
    const completed = sections.filter((s) => s.done).length;
    const percent = Math.round((completed / total) * 100);

    return { percent, sections };
  }, [user, docData, workingHours, hoursConfigured]);

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0">Profile Completion</h6>
          <Badge bg={result.percent === 100 ? "success" : "secondary"}>
            {result.percent}%
          </Badge>
        </div>
        <ProgressBar
          now={result.percent}
          variant={result.percent === 100 ? "success" : "primary"}
          style={{ height: "8px" }}
        />
        <div className="mt-3 d-flex flex-wrap gap-2">
          {result.sections.map((s) => (
            <span
              key={s.key}
              className={`badge ${s.done ? "bg-success" : "bg-light text-muted border"}`}
            >
              {s.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SchoolProfileProgress;
